import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updatePolygon as updateCustomPolygon } from '@api/map';

import { ICustomPolygonDTO } from '@interfaces/map/dto/polygonDTO';

import { ESnackbarTypes } from '@enums/common';

import { BOROUGHS, CUSTOM_POLYGON, UPDATE_POLYGON } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdatePolygon = (onSuccessCallback?: (data: ICustomPolygonDTO) => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { isLoading: isUpdating, mutateAsync: updatePolygon } = useMutation({
		mutationKey: [UPDATE_POLYGON],
		mutationFn: updateCustomPolygon,
		onSuccess: (data: ICustomPolygonDTO) => {
			dispatch(setSnackbar({
				message: responseMessages.updatePolygon,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallback) onSuccessCallback(data);

			return [
				queryClient.invalidateQueries([CUSTOM_POLYGON]),
				queryClient.invalidateQueries([BOROUGHS]),
			];
		},
	});

	return {
		isUpdating,
		updatePolygon,
	};
};
